import { useMutation } from "react-query";
import { DeleteVehiclesParams, deleteTEMPVehicles } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

export const deleteTEMPVehiclesFn = async (params: DeleteVehiclesParams) => {
  return await deleteTEMPVehicles(params);
};

export function useDeleteMultipleTEMPVehicles() {
  return useMutation(deleteTEMPVehiclesFn, {
    mutationKey: MUTATION_KEYS.deleteMultipleTEMPVehicles,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
